// 고객 후기 링크 액션(rpc, legacy modules/review/share-actions) — 후기 남기기·고치기 · 토큰은 input.token.
import { shareRpc } from "@/api/client";

export const saveCustomerReviewByLink = (input: { token: string; body: string; anonymous: boolean; consent_public: boolean }) =>
  shareRpc("c", input.token, "saveCustomerReviewByLink", input);
